import {
  Card, Input,
  CardBody
} from 'reactstrap';
import axiosInstance from '../../helpers/axios';
import { useState, useEffect } from 'react';
import 'react-datetime/css/react-datetime.css';
import { useNavigate } from 'react-router-dom';
import PaginationTable from '../status/PaginationTable';
import './UserSearch.css';
import { useDispatch, useSelector } from "react-redux";
import * as moment from 'moment';
import { userActions } from '../../actions/user.actions';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { appContextConstants } from '../../constants/appContext.constants';
export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}


const SearchTable = () => {
  const dispatch = useDispatch();
  const productTypeSelected = useSelector(
    (state) => state.ProductTypeFilter.selectedProductType
  );
  const navigate=useNavigate();
  //filter

  const [searchUser, setSearchUser] = useState("");
  const [studentId, setStudentId] = useState("");
  const debouncedSearchUser = useDebounce(searchUser, 200); 
  //table
  const [tableData, setTableData] = useState([]);
  
  //pagination
  const [currentPage, setcurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [totalFetchRows, setTotalFetchRows] = useState(null);

   //sorting
  const decode = useCurrentUser();
  const user = null;
  const restrictedRoles = ["institute_admin", "institute_user", "channel_user"];
  const isRestrictedRole = restrictedRoles.includes(decode?.role);
  const [sort,setSort]=useState(-1)
  //onclick Search
  const handleLoanProfile = (item) => {
    if (!item?.loanId) {
      alert("Loan Profile is not available for this application yet");
      return;
    }
    dispatch({ type: appContextConstants.SET_ACTIVITY_CONTEXT, payload: { activityAppStatus: item.status } });

    const urlUsers = `/loan-repayment/profile?loanId=${item.loanId}`;
    const callDetailsUrl = `/call-history/details?loanId=${item.loanId}`;
    const emihistoryUrl = `/emis/for-loan?loanId=${item.loanId}`;

    dispatch(userActions.fetchLoanDetails(urlUsers, user));
    dispatch(userActions.fetchCallDetails(callDetailsUrl, user));
    dispatch(userActions.getEmiHistory(emihistoryUrl, user));

    window.open(`/LoanProfile?loanId=${item.loanId}&legacyLoanId=${item.legacyLoanId || ''}`, "_blank");
  };
 
  const handleUserApplication=(applItem)=>{
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { status: applItem.status } });

 setTableData([])
    if(applItem.status==="Pending Disbursement")
    {
      
            const pendignUsers = `/disbursement/payouts?applicationId=${applItem.applicationId}&perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${sort}`;
        dispatch(userActions.userSearch(pendignUsers,navigate,applItem.status, user),[])
        
    }
    else if(applItem.status==='In Sanction')
    {
        const sanctionUrl=`/integrations/applications?applicationId=${applItem.applicationId}&perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${sort}`;
        dispatch(userActions.userSearch(sanctionUrl,navigate,applItem.status, user),[])
    }
    else if(applItem.status==="Ready to Disburse")
    {
    
         const readyToDisburseUrl=`/integrations/applications?status=Ready%20to%20Disburse&applicationId=${applItem.applicationId}&perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${sort}`;
         dispatch(userActions.userSearch(readyToDisburseUrl,navigate,applItem.status, user),[])

    }

    else if(applItem.status==="In Process")
    {
         const urlUsers = `/admin/application/in-progress?applicationId=${applItem.applicationId}&perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${sort}`;
         dispatch(userActions.userSearch(urlUsers,navigate,applItem.status, user),[])
        
    }
    else
    {

      const getAppUrl=`/admin/application/id?applicationId=${applItem.applicationId}`;
      
      dispatch(userActions.userSearchdefault(getAppUrl,applItem.status,navigate,user))
      
    }
  }
  // const handleInstituteApplication=(item)=>{
  //   
  //   if(item.status === "In Process" || item.status === "In Submission" || item.status === "In Review" || item.status === "In Sanction" || item.status === "In Disbursement" || item.status === "Ready to Disburse"){
  //     const urlUsers = `/admin/application/institute-search?applicationId=${item.applicationId}`;

  //     dispatch(userActions.userSearchInst(urlUsers,item.status,navigate,user))
  //   }
  //   else if(item.status === "Disbursed"){
  //     const urlUsers = `/admin/application/institute-search?applicationId=${item.applicationId}`;

  //     dispatch(userActions.userSearchInst(urlUsers,item.status,navigate,user))
  //   }
  //   else if(item.status === "Dropped"){
  //     const urlUsers = `/admin/application/institute-search?applicationId=${item.applicationId}`;

  //     dispatch(userActions.userSearchInst(urlUsers,item.status,navigate,user))
  //   }
  //   else if(item.status === "Rejected"){
  //     const urlUsers = `/admin/application/institute-search?applicationId=${item.applicationId}`;

  //     dispatch(userActions.userSearchInst(urlUsers,item.status,navigate,user))
  //   }
  //   else if(item.status === "On Hold"){
  //     const urlUsers = `/admin/application/institute-search?applicationId=${item.applicationId}`;

  //     dispatch(userActions.userSearchInst(urlUsers,item.status,navigate,user))
  //   }
   

  // }
  let queryParams = {}

  if (
    productTypeSelected &&
    productTypeSelected !== "all"
  ) {
    queryParams.productType = Number(productTypeSelected)
  }

  const urlUsers = `/users/basic-info?searchField=${debouncedSearchUser?debouncedSearchUser.length>=5?debouncedSearchUser:undefined:undefined}`;
  const urlUsersId = `/admin/application/search?applicationId=${debouncedSearchUser}`;
  const studentIdUrl = `/admin/application/get-details`

  const handleSearch=()=>{
    if(studentId && decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e"){
      let queryParams = {}
      
      if(studentId){
        queryParams.studentId = studentId
      }
      queryParams.instituteId = decode.instituteId
      axiosInstance.get(studentIdUrl,{
        params:queryParams,
        headers: {
        },
      })
      .then((res) => {
          
        if(res?.data?.data!==null)
        {
    
          
          setTableData(res?.data?.data);
         
          // setcurrentPage(res.data.data.pagination.currentPage);
          // setTotalFetchRows(res.data.data.pagination.totalRows);
          // setrowsPerPage(res.data.data.pagination.perPage);
        }
      }).catch((error)=>{
        alert(error?.response?.data?.message)
      })
      
    }else{
      if(searchUser.length >= 10 && (searchUser.substring(0, 3) === "FM2" ||searchUser.substring(0, 3) === "BJ2")){
        axiosInstance.get(urlUsersId,{
          params: queryParams,
          headers:{
        }}).then((res) => {
          if(res?.data?.data!==null)
          {
      
          
            setTableData(res?.data?.data);
           
            // setcurrentPage(res.data.data.pagination.currentPage);
            // setTotalFetchRows(res.data.data.pagination.totalRows);
            // setrowsPerPage(res.data.data.pagination.perPage);
          }
          
        }).catch((error)=>{
          alert(error?.response?.data?.message)
        })
      }else{
        axiosInstance.get(urlUsers,{
          params: queryParams,
          headers:{
        }}).then((res) => {
          
          if(res?.data?.data!==null)
          {
      
            
            setTableData(res?.data?.data);
           
            // setcurrentPage(res.data.data.pagination.currentPage);
            // setTotalFetchRows(res.data.data.pagination.totalRows);
            // setrowsPerPage(res.data.data.pagination.perPage);
          }
        }).catch((error)=>{
          alert(error?.response?.data?.message)
        })
      }
    }
   
  
}

  useEffect(() => {
    setTableData([]);
    handleSearch();
  }, [debouncedSearchUser, studentId, productTypeSelected]);

  
  //changepage
  const paginate = (pageNumber) => {
    setcurrentPage(pageNumber);
  };

  if (tableData) {
    return (
      <Card style={{width:"100%",height:'100%'}}>

        <CardBody>
         <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
           <Input  style={{border:'1px solid #D0D5DD',width:'40%',height:'40px',borderRadius:'10px',marginTop:'20px',fontFamily: "Inter-Medium"}}type='text' onChange={(e)=>setSearchUser(e.target.value)} placeholder='Enter at least 5 characters of Applicant Name or Phone number'/> 
          {decode?.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e"?(<Input  style={{border:'1px solid #D0D5DD',width:'40%',height:'40px',borderRadius:'10px',marginTop:'20px',fontFamily: "Inter-Medium"}}type='text' onChange={(e)=>setStudentId(e.target.value)} placeholder='Enter Student Id'/>):null}  

           </div>
          <div className='tables'style={{ marginTop: '30px' }}>
            <table>
              <thead className='table-heading'>
                <tr>
                  <th className="thead-text" style={{  fontSize: '1vw',fontFamily: "Inter-Medium",width:'15em' }} id="appId">
                  <span style={{marginLeft:'10px'}}></span>  Appl. Id
                  {/* <img style={{cursor:'pointer',width:'14px',fontFamily: "Inter-Medium"}} src={Sort} alt="sort"/> */}
                  </th>
                  <th className="thead-text" style={{  fontSize: '1vw',fontFamily: "Inter-Medium",width:'20em' }} id="appname">
                  <span style={{marginLeft:'10px'}}></span>   Appl. Name
                  </th>
                  <th className="thead-text" style={{  fontSize: '1vw',fontFamily: "Inter-Medium",width:'20em' }} id="insName">
                  <span style={{marginLeft:'10px'}}></span>{ decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Product Type': 'Institute Name'}
                  </th>
                  <th className="thead-text" style={{  fontSize: '1vw',fontFamily: "Inter-Medium" ,width:'20em'}} id="coursename">
                  { decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Loan Amount': 'Course Fees'}
                  </th>
                  <th className="thead-text" style={{  fontSize: '1vw',fontFamily: "Inter-Medium",width:'20em' }} id="status">
                  <span style={{marginLeft:'10px'}}></span> Status
                  </th>
                  <th className="thead-text"  style={{  fontSize: '1vw',cursor:'pointer',fontFamily: "Inter-Medium",width:'25em' }} id="appfromdate">
                   Applied On
                  </th>
                    {!isRestrictedRole && (
                    <th className="thead-text" style={{ fontSize: '1vw', cursor: 'pointer', fontFamily: "Inter-Medium", width: '25em' }} id="appfromdate">
                    Loan Profile
                    </th>
                    )}
                </tr>
              </thead>
              {Array.isArray(tableData) && tableData?.map((item) => {
              
                  return (
                    <tbody className='table-body' key={item.applicationId}>
                      <tr className='table-row'
                       onClick={decode.role === "institute_admin" || decode.role === "institute_user" || decode.role === "channel_user" ? () => handleUserApplication(item) :() => handleUserApplication(item)}
                        style={{ lineHeight: '28px' }}>
                        <td style={{cursor:'pointer',  fontSize: '1vw', fontWeight: '400', width: '10em',fontFamily: "Inter-Medium" }}>
                          {item.applicationId}
                        </td>
                        <td
                          style={{
                             fontSize: '1vw',
                            width: '18em',fontFamily: "Inter-Medium"
                          }}
                        >
                          <span style={{fontFamily: "Inter-Medium", fontSize: '1vw'}}>{item.name}</span>
                          {item.coapplicantName ? (
                            <span style={{fontFamily: "Inter-Medium", fontSize: '1vw'}}>
                              
                              | {item.coapplicantName} ( C )
                            </span>
                          ) : (
                            ''
                          )}
                        </td>
                        <td style={{  fontSize: '1vw', fontWeight: '400', width: '13em',fontFamily: "Inter-Medium", color: '#667085' }}>
                          {item.instituteName}
                        </td>
                        <td style={{  fontSize: '1vw', fontWeight: '400', width: '13em',fontFamily: "Inter-Medium", color: '#667085' }}>
                          {item.courseFees}
                        </td>
                        <td style={{  fontSize: '1vw', fontWeight: '400', width: '13em' ,fontFamily: "Inter-Medium", color: '#667085'}}>
                          {item.status}
                        </td>
                       
                        <td
                          title={item.appliedOn}
                          style={{ width: '10em', fontWeight: '400',  fontSize: '1vw',fontFamily: "Inter-Medium" }}
                        >
                          {moment(item.appliedOn).format('DD MMM YYYY')}
                        </td>
                        {!isRestrictedRole && (
                        <td
                         
                          style={{ textAlign: 'center', fontFamily: "Inter-Medium" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!item?.loanId) {
                              return;
                            }
                            handleLoanProfile(item);
                          }}
                        >
                          {item?.loanId?(
                            <span title='Click to view Loan Profile'>
                              <OpenInNewIcon
                                style={{
                                  marginRight: '70px',
                                  color: item?.loanId ? '#D22129' : '#98A2B3',
                                  cursor: item?.loanId ? 'pointer' : 'not-allowed',
                                }}
                              />
                              </span>
                          ):(
                                <span
                                  title="No loan exists for this application"
                                  style={{
                                    color: '#98A2B3', fontSize: '0.95vw', display: 'block',
                                    textAlign: 'left',   
                                    paddingLeft: '3px'
}}>
                                  No Loan exists
                                </span>
                          )
                        }
                          
                        </td>
                        )}
                      </tr>
                      
                    </tbody>
                  );
              })}
            </table>
            </div>

            {totalFetchRows ? (
              <div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter-Medium", fontSize: '14px',marginLeft:'10px' ,marginBottom:'5px'}}>
                Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage}{' '}
                records
              </div>
            ) : (
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily:"Inter-Medium", fontSize: '14px' }}>No Records</div>
            )}
            <PaginationTable
              startPage="1"
              rowsPerPage={rowsPerPage}
              totalRows={totalFetchRows}
              paginate={paginate}
            />
          
        </CardBody>
      </Card>
    );
  }
  return <div>....Loading</div>;
};

export default SearchTable;

